/**
 * Stored audience names are sometimes slug-shaped (`Fresh_Produce_&_Salad_Kits`).
 * When the stored name has no spaces of its own, show the underscores as spaces.
 * A name that already has spaces is left as stored.
 */
export function audienceDisplayName(name: string | null | undefined): string {
  const trimmed = (name ?? '').trim()
  if (!trimmed.includes('_') || /\s/.test(trimmed)) {
    return trimmed
  }
  return trimmed.replace(/_+/g, ' ')
}
